import { render, staticRenderFns } from "./TaskPromptModal.vue?vue&type=template&id=c21ed6b4"
import script from "./TaskPromptModal.vue?vue&type=script&lang=js"
export * from "./TaskPromptModal.vue?vue&type=script&lang=js"
import style0 from "./TaskPromptModal.vue?vue&type=style&index=0&id=c21ed6b4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports